import { ChevronDownMedium } from '@zoopla-eng/zds-components/icons';
import { fontGroups } from '@zoopla-eng/zds-components/themes/font-groups';
import {
    iconContainerStyle,
    selectWrapperStyle,
    styledLabelStyle,
    styledSelectStyle
} from './Filters.styles.css';

const searchRadii = [
    '',
    '0',
    '0.25',
    '0.5',
    '1',
    '3',
    '5',
    '10',
    '15',
    '20',
    '30',
    '40'
];

const radiiOptions = [
    { value: '0', text: 'This area only' },
    { value: '0.25', text: '+ 0.25 miles' },
    { value: '0.5', text: '+ 0.5 miles' },
    { value: '1', text: '+ 1 miles' },
    { value: '3', text: '+ 3 miles' },
    { value: '5', text: '+ 5 miles' },
    { value: '10', text: '+ 10 miles' },
    { value: '15', text: '+ 15 miles' },
    { value: '20', text: '+ 20 miles' },
    { value: '30', text: '+ 30 miles' },
    { value: '40', text: '+ 40 miles' }
];

export type Radius = (typeof searchRadii)[number];

type SelectRadiusProps = {
    value: Radius | Radius[];
    onChange: (radius: Radius | Radius[]) => void;
};

export const SelectRadius = ({ value, onChange }: SelectRadiusProps) => {
    return (
        <div className={selectWrapperStyle}>
            <label
                className={`${styledLabelStyle} ${fontGroups.ladle}`}
                htmlFor="radius"
            >
                Radius
            </label>
            <select
                className={`${styledSelectStyle} ${fontGroups.ladle}`}
                id="radius"
                name="radius"
                onChange={(e) => {
                    onChange(e.target.value as Radius);
                }}
                value={value}
            >
                {radiiOptions.map((radiusOption, index) => {
                    return (
                        <option
                            value={radiusOption.value}
                            key={`radius_option_${index}`}
                        >
                            {radiusOption.text}
                        </option>
                    );
                })}
            </select>
            <div className={iconContainerStyle}>
                <ChevronDownMedium />
            </div>
        </div>
    );
};
